import Util from '@/utils/util'
import Axs from '@/utils/axs'
import { defineStore } from 'pinia'
import storeInfoFun from '@/info.js'

let storeFunc = defineStore("zhsq", {
    state: () => {
        return {
            //业务数据  count:99
            openedfunsViewArr: [],
            tabSelected: "",
            funsLayout: "",
            funsLayoutTitle: "",
            funsLayoutSearchs:null,
            treeData: null,
            ComfirEnum: [{
                id: 0,
                label: "否"
            },
            {
                id: 1,
                label: "是"
            }],
            IdentityTypeEnum: [{
                id: 1,
                label: "身份证"
            },
            {
                id: 2,
                label: "护照"
            },
            {
                id: 3,
                label: "港澳台通行证"
            }],
            SexEnum:[
                {
                    id: 0,
                    label: "未输入"
                },
                {
                    id: 1,
                    label: "男"
                },
                {
                    id: 2,
                    label: "女"
                },
            ],
            ApproveEnum: [
                {
                    id: 0,
                    label: "待审核"
                },
                {
                    id: 1,
                    label: "审核中"
                },
                {
                    id: 2,
                    label: "已审核"
                },
                {
                    id: 3,
                    label: "驳回"
                },
            ],
            goodsTypeEnum:[
                {
                    id: 0,
                    label: "实体商品"
                },
                {
                    id: 1,
                    label: "服务/虚拟/课堂/疗程"
                },
            ],

            dataTypeEnum:[
                {
                    id: 0,
                    label: "未知"
                },
                {
                    id: 1,
                    label: "文章/新闻"
                },
                {
                    id: 2,
                    label: "学堂招生"
                },
                {
                    id: 3,
                    label: "房源信息"
                },
                {
                    id: 4,
                    label: "问卷调查"
                },
                {
                    id: 5,
                    label: "商品营销"
                },
                {
                    id: 6,
                    label: "生活互动"
                },
                {
                    id: 7,
                    label: "招聘信息"
                },
                {
                    id: 8,
                    label: "物业信息"
                },
                {
                    id: 9,
                    label: "游戏竞赛"
                },
                {
                    id: 10,
                    label: "惠民商家"
                },
                {
                    id: 11,
                    label: "同城服务"
                },
                {
                    id: 12,
                    label: "小区物业资讯"
                },
                {
                    id: 13,
                    label: "live视频/直播"
                },
            ],
            merchantModeTypeEnum:[
                {
                    id: 0,
                    label: "普通商家/零售"
                },
                {
                    id: 1,
                    label: "学堂/教育机构"
                },
                {
                    id: 2,
                    label: "餐饮/酒店"
                },
                {
                    id: 3,
                    label: "服务业"
                },
                {
                    id: 4,
                    label: "批发商/厂商"
                },
                {
                    id: 5,
                    label: "虚拟服务商"
                },
                {
                    id: 6,
                    label: "平台商家"
                },
            ],
         
            appEnablesEnum:[
                {
                    id: 0,
                    label: "预约"
                },
                {
                    id: 1,
                    label: "支付"
                },
                {
                    id: 2,
                    label: "积分兑换"
                },
                {
                    id: 3,
                    label: "志愿星兑换"
                },
                {
                    id: 4,
                    label: "优惠卷兑换"
                },
                {
                    id: 5,
                    label: "积分抵扣"
                },
            ],

            merchantAuthorityEnum: [
                {
                    id: 0,
                    label: "商户信息"
                },
                {
                    id: 1,
                    label: "客服"
                },
                {
                    id: 2,
                    label: "商家订单"
                },
                {
                    id: 3,
                    label: "商家账户"
                },
                {
                    id: 4,
                    label: "操作用户"
                },
                {
                    id: 5,
                    label: "发票管理"
                },
                {
                    id: 6,
                    label: "消息推送"
                },
                {
                    id: 7,
                    label: "扫码提货"
                },
                {
                    id: 8,
                    label: "商品管理"
                },
                {
                    id: 9,
                    label: "商品预约"
                },
                {
                    id: 10,
                    label: "学堂资源"
                },
                {
                    id: 11,
                    label: "招生发布"
                },
                {
                    id: 12,
                    label: "学堂预约"
                },
                {
                    id: 13,
                    label: "学堂学员"
                },
                {
                    id: 14,
                    label: "房源信息"
                },
                {
                    id: 15,
                    label: "我要招聘"
                },
                {
                    id: 16,
                    label: "查看应聘"
                },
                {
                    id: 17,
                    label: "锁客粉丝"
                },
                {
                    id: 18,
                    label: "收款码"
                }
            ],
            MERCHANTAUTHORITY_DEFAULT: "1 1 1 1 1 1 1 1 1 1 0 0 0 0 1 1 1 1 1 1 1",
            MERCHANTAUTHORITY_MASTER: "1 1 1 1 1 1 1 1 1 1 0 0 0 0 1 1 1 1 1 1 1",
            MERCHANTSCHOOLAUTHORITY_DEFAULT: "1 1 1 1 1 1 1 1 0 0 1 1 1 0 0 0 1 1 1 1 1",
            MERCHANTSCHOOLAUTHORITY_MASTER: "1 1 1 1 1 1 1 1 0 0 1 1 1 0 0 0 1 1 1 1 1",
            sendGoodsTypeEnables:[
                {
                    id: 0,
                    label: "扫码自提"
                },
                {
                    id: 1,
                    label: "快递物流发货"
                },
                {
                    id: 2,
                    label: "虚拟发货"
                },
       
            ],
            receiveTypeEnum: [
                {
                    id: 0,
                    label: "个人借记卡/储蓄卡"
                },
                {
                    id: 1,
                    label: "对公账号"
                },
                {
                    id: 2,
                    label: "信用卡"
                },
                {
                    id: 3,
                    label: "第三方记账"
                },
                {
                    id: 4,
                    label: "微信商户"
                },
                {
                    id: 5,
                    label: "微信"
                },
            ],

            PaymentTypeEnum:[
                {
                    id: 0,
                    label: "微信支付"
                },
                {
                    id: 1,
                    label: "支付宝支付"
                },
                {
                    id: 2,
                    label: "储蓄卡/银行账户"
                },
                {
                    id: 3,
                    label: "平台余额"
                },
                {
                    id: 4,
                    label: "积分"
                },
                {
                    id: 5,
                    label: "志愿星"
                },
            ],
        }
    },
    actions: {
        clear() {
            //console.log("openedfunsViewArr清理了3333333333333?????????????")
            this.openedfunsViewArr = [];
            this.tabSelected = "";
            this.funsLayout = "";
            this.funsLayoutTitle = "";
            this.funsLayoutSearchs = null;
            this.treeData = null;
        },
        async getStatisticsAllData()
        {
             let storeInfo = storeInfoFun();
             let url = storeInfo.linkUrl + "api/zhsq/statistics/getAllData";
         
             let ret = await Axs.getAsync(url, {}, null)
             if(Util.isEmpty(ret))
                return null;
    
             //console.log("api/zhsq/statistics/getAllData",ret);
             return ret
        },
        async getStatisticsAllUsersActive(type)
        {
            let storeInfo = storeInfoFun();
            let url = storeInfo.linkUrl + "api/zhsq/statistics/getAllUsersActive";
        
            let ret = await Axs.getAsync(url, {
                type
            }, null)
            if(Util.isEmpty(ret))
               return null;

            //console.log("api/zhsq/statistics/getAllData",ret);
            return ret
        },
        async getStatisticsAllUserOrders(type)
        {
            let storeInfo = storeInfoFun();
            let url = storeInfo.linkUrl + "api/zhsq/statistics/getAllUserOrders";
        
            let ret = await Axs.getAsync(url, {
                type
            }, null)
            if(Util.isEmpty(ret))
               return null;

            //console.log("api/zhsq/statistics/getAllData",ret);
            return ret
        },
        async getStatisticsAllIncome(type)
        {
            let storeInfo = storeInfoFun();
            let url = storeInfo.linkUrl + "api/zhsq/statistics/getAllIncome";
        
            let ret = await Axs.getAsync(url, {
                type
            }, null)
            if(Util.isEmpty(ret))
               return null;

            //console.log("api/zhsq/statistics/getAllData",ret);
            return ret
        }
        
    },
    getters: {
        //计算属性，只读属性
    },
    persist: true
})

//组合式写法 mixin混合写法
// let storeFunc = defineStore("user",()=>{
//     //组合式写法
//     let p = ref("xx");
//     return {
//         p
//     }
// })


export default storeFunc